module.exports = __webpack_public_path__ + "img/bg-location.ec1ec71b.jpg";